import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../redux/store";
import { T } from "react-translator-component";
import { colors } from "../../../common/colors";
import { setItem } from "../../redux/createOpinionReducer";
import Section from "../editors/Section";
import DropDown from "../DropDown";

interface Props {
  categories: any[]
}

export default function SelectCategory({ categories }: Props) {
  const dispatch = useAppDispatch();

  const category = useSelector((state: any) => state.createOpinion.values.category);
  const error = useSelector((state: any) => state.createOpinion.errors.category);

  return (
    <Section
      title={`${T("post_category")}${T("required")}`}
          body={(
        <DropDown
          sx={{
            marginTop: 2,
            width: "100%",
            justifyContent: "left",
            backgroundColor: colors.farm_white,
          }}
          title={T("post_category")}
          options={categories}
          value={category}
          errorMessage={error}
          onChange={(e) => dispatch(setItem({key: 'category', value: String(e.target.value)}))}
        />
      )}
      style={{ marginTop: 0 }}
    />
  )
}
